/* eslint-disable no-console */

import { register } from 'register-service-worker'

if (window.app.config.NODE_ENV === 'production') {
  register( 'service-worker.js', {
    ready () {
      console.log(
        'App is being served from cache by a service worker.\n' +
        'For more details, visit https://goo.gl/AFskqB'
      )
    },
    registered () {
      console.log('Service worker has been registered.')
    },
    cached () {
      console.log('Content has been cached for offline use.')
    },
    updatefound () {
      console.log('New content is downloading.')
    },
    updated (registration) {
      console.log('New content is available; please refresh.')
      /* UpdatePrompt.vue offers the reload. Nothing else listens, so this is inert when the
         brand has not set VUE_APP_UPDATE_PROMPT. */
      window.dispatchEvent(new CustomEvent('sw:updated', {detail: registration}))
    },
    offline () {
      console.log('No internet connection found. App is running in offline mode.')
    },
    error (error) {
      console.error('Error during service worker registration:', error)
    }
  })
}
